var _style, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoCamera483(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9FA3A2;}\r\n\t.st1{fill:none;stroke:#9FA3A2;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,50.7c2.4,0,4.4-0.8,6.1-2.5c1.6-1.6,2.5-3.7,2.5-6.1c0-2.4-0.8-4.4-2.5-6c-1.6-1.6-3.7-2.4-6.1-2.4 c-2.4,0-4.4,0.8-6,2.4c-1.6,1.6-2.4,3.6-2.4,6c0,2.4,0.8,4.4,2.4,6.1C35.5,49.9,37.6,50.7,40,50.7z M40,47.7c-1.6,0-2.9-0.5-3.9-1.6 s-1.5-2.4-1.5-4c0-1.6,0.5-2.9,1.5-3.9s2.3-1.5,3.9-1.5c1.6,0,2.9,0.5,4,1.5c1.1,1,1.6,2.3,1.6,3.9c0,1.6-0.5,2.9-1.6,4 C42.9,47.2,41.6,47.7,40,47.7z M23,58c-0.8,0-1.5-0.3-2.1-0.9C20.3,56.5,20,55.8,20,55V29.4c0-0.8,0.3-1.5,0.9-2.1s1.3-0.9,2.1-0.9 h7.4L34,22h12l3.7,4.4H57c0.8,0,1.5,0.3,2.1,0.9s0.9,1.3,0.9,2.1V55c0,0.8-0.3,1.5-0.9,2.1C58.5,57.7,57.8,58,57,58H23z M57,55V29.4 h-8.8L44.6,25h-9.2l-3.7,4.4H23V55H57z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40,
    cy: 40,
    r: 39
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCamera483);
export default __webpack_public_path__ + "static/media/photo_camera483.b55630cdfd794c0a799f4cd591a39f4f.svg";
export { ForwardRef as ReactComponent };